import type { LightUser } from './user';

export enum AuditActions {
  CREATE = 'create',
  UPDATE = 'update',
}

type NumberFromTo = [number, number];
type TextFromTo = [string, string];
type BooleanFromTo = [boolean, boolean];

export interface RawHourAuditChanges {
  day: TextFromTo;
  note: TextFromTo;
  hours: NumberFromTo;
  minutes: NumberFromTo;
  hour_rate: NumberFromTo;
  billed_at: BooleanFromTo;
  project_id: NumberFromTo;
}

// Working under the assumption that the Audit payload will be the same across entities
// but that the shape of changes will be different depending on what we're updating
// e.g. hour, user, project, foreceast etc.
export interface RawAudit<T> {
  id: number;
  version: number;
  user: Pick<LightUser, 'id' | 'email' | 'name' | 'avatar' | 'updated_at'>;
  username: string | null;
  changes: Partial<T>;
  action: AuditActions;
  created_at: string;
}
